import { TicketItem } from 'shared/models/ticket'

export type AviaStoredSelection = {
  ticket: TicketItem
  tarrifTicket?: TicketItem
}

export const parseAviaShareStorage = (
  raw: unknown,
): AviaStoredSelection | null => {
  if (!raw || typeof raw !== 'object') return null

  const o = raw as Record<string, unknown>

  if (o.ticket && typeof o.ticket === 'object') {
    const result: AviaStoredSelection = {
      ticket: o.ticket as TicketItem,
    }

    if (o.tarrifTicket && typeof o.tarrifTicket === 'object') {
      result.tarrifTicket = o.tarrifTicket as TicketItem
    }

    return result
  }

  return { ticket: raw as TicketItem }
}
